// Work Experience Data
const workExperience = [
    {
        id: 'imdb',
        company: 'IMDb',
        role: 'Software Development Engineer II',
        startDate: 'August 2024',
        endDate: 'Present',
        description: 'Developed features for IMDb web and mobile applications, improving user experience for millions of users.',
        logo: null
    },
    {
        id: 'prime-gaming',
        company: 'Prime Gaming',
        role: 'Software Development Engineer II',
        startDate: 'October 2020',
        endDate: 'August 2024',
        description: 'Developed user-facing features and backend services for the Prime Gaming platform as part of the Accounts and Signups team. Built scalable solutions for account management, authentication, and user onboarding experiences.',
        logo: null
    },
    {
        id: 'alexa-for-business',
        company: 'Alexa for Business',
        role: 'Software Development Engineer',
        startDate: 'December 2019',
        endDate: 'October 2020',
        description: 'Developed conference room connectivity features for Alexa for Business platform.',
        logo: null
    },
    {
        id: 'commerce-bank',
        company: 'Commerce Bank',
        role: 'Software Developer',
        startDate: 'June 2017',
        endDate: 'November 2019',
        description: 'Enhanced a customer relationship management tool for banking professionals to connect with clients.',
        logo: null
    },
    {
        id: 'umkc',
        company: 'University of Missouri-Kansas City',
        role: 'Bachelor of Science in Computer Science',
        startDate: 'August 2013',
        endDate: 'May 2017',
        description: 'Graduated with a degree in Computer Science.',
        logo: null
    }
];

export default workExperience;
